module.exports = __webpack_public_path__ + "img/kayak001.c11f7929.jpg";